var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8515 16.6248L3.00055 12.6139H0.398926V10.7711H3.52088L4.82169 6.305H2.22006V4.46218H5.34202L6.49107 0.473022H8.59405L7.445 4.46218H11.6726L12.8217 0.473022H14.9464L13.7973 4.46218H16.3989V6.305H13.2553L11.9762 10.7711H14.5778V12.6139H11.4558L10.3068 16.6248H8.18212L9.33117 12.6139H5.10353L3.95448 16.6248H1.8515ZM5.64554 10.7711H9.87318L11.1523 6.305H6.92467L5.64554 10.7711Z",
    fill: "#27548C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber);
export default __webpack_public_path__ + "static/media/number.1723449b55c03cba4b78ce5df2245566.svg";
export { ForwardRef as ReactComponent };